// extracted by mini-css-extract-plugin
export default {"holder":"Select_holder__URU9d","error":"Select_error__uJ69v","option":"Select_option__jIP3s"};